import { useEffect } from 'react';
import { useTranslation } from '@frontend/i18n';
import { FormFieldActionTypes, useForm } from '@frontend/design-system';

export const useAppointmentTypePaymentFields = (initialAmount = 0) => {
  const { t } = useTranslation('scheduleAppointmentTypes');

  const { values, getFieldProps, reset, seedValues } = useForm({
    fields: {
      requireDeposit: {
        type: 'switch',
        value: !!initialAmount && initialAmount > 0,
      },
      amount: {
        type: 'money',
        value: (initialAmount || 0).toFixed(2),
        validateOnChange: true,
        validator: ({ value }) => {
          const amount = Number(value);
          if (amount <= 0) return t('Amount must be greater than 0');
          if (!Number.isInteger(amount)) return t('Whole dollar amounts only');
          return '';
        },
      },
    },
    fieldStateReducer: (state, action) => {
      if (action.type === FormFieldActionTypes.Update && action.payload.name === 'requireDeposit') {
        const requireDeposit = action.payload.value;
        return {
          ...state,
          amount: {
            ...state.amount,
            value: requireDeposit ? state.amount.value : (initialAmount || 0).toFixed(2),
            error: requireDeposit ? state.amount.error : '',
            required: !!requireDeposit,
          },
        };
      }
      return state;
    },
  });

  useEffect(() => {
    seedValues({
      requireDeposit: !!initialAmount && initialAmount > 0,
      amount: (initialAmount || 0).toFixed(2),
    });
  }, [initialAmount, seedValues]);

  const depositAmount =
    values.requireDeposit && values.amount && Number.isInteger(Number(values.amount))
      ? parseInt(values.amount, 10) || 0
      : 0;
  const isFormComplete = !values.requireDeposit || depositAmount > 0;

  return {
    depositAmount,
    getFieldProps,
    isFormComplete,
    reset,
  };
};
